import { DatePipe } from '@angular/common';
import { TranslatePipe } from '../../../filters/translate.pipe';
import { ItemInfoPopoverComponent } from '../../../components/item-info-popover/item-info-popover.component';
import { LoaderOverlayComponent } from '../../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ModalInsertForPersonCreateUserComponent } from '../../../components/pre-visit/insert-for-person/modal-create-user/modal-create-user.component';
import Session from '../../../utils/session.service';
import RestService from '../../../services/core-rest.service';
import RoutingService from '../../../services/routing.service';
import DialogServices from '../../../services/dialog.service';
import AngularFilterHelperService from '../../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import PreVisitRecordTicketForPersonService from '../../../services/pre-visit-record-ticket-for-person.service';
import Toast from '../../../services/toast.service';

@Component({
	standalone: true,
	selector: 'pre-visit-insert-for-person-list',
	templateUrl: './pre-visit-insert-for-person-list.component.html',
	imports: [
		CommonModule, DatePipe, TranslatePipe,
		ItemInfoPopoverComponent, LoaderOverlayComponent, 
		FormsModule, RouterLink
	]
})
export default class PreVisitInsertForPersonListComponent implements OnInit {
	private session: Session = inject(Session);
	private restService: RestService = inject(RestService);
	private routingService: RoutingService = inject(RoutingService);
	private dialogServices: DialogServices = inject(DialogServices);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private preVisitRecordTicketForPersonService: PreVisitRecordTicketForPersonService = inject(PreVisitRecordTicketForPersonService);
	private toast: Toast = inject(Toast);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('preVisitDashboard').then(() => {
			this.onResolve();
		});
	}
	
	onResolve() {
		this.vm.loading = true;

		this.vm.settings = this.preVisitRecordTicketForPersonService.getSettings();
		if (!this.vm.settings) {
			this.angularRoutingHelperService.setPath('/pre-visit');
			return;
		}
		
		this.preVisitRecordTicketForPersonService.setRequestRecorder(this.session.getSession());
		this.preVisitRecordTicketForPersonService.setRequester(this.session.getSession());
		
		this.vm.manuallyAddedDisclaimer = this.angularFilterHelperService.translate('PreVisit.Insert_For_Person_List.Add_New_Manually_Disclaimer')

		this.restService.getPreVisitCareTakenHistory({})
			.then((response: Array<any>) => {
				if (response.length == 1 && response[0].statusInfo === 'EMPTY') {
					this.vm.persons = undefined;
				} else {
					this.vm.persons = response;
				}
				this.loadLastCheckDate(this.vm.persons);
				this.vm.loading = false;
			})
			.catch((error) => {
				console.log(error);
			});

	}
	
	loadLastCheckDate(persons: Array<any>) {
		if (persons) {
			persons.forEach((person) => {
				if (person.statusInfo === 'EMPTY' || person.source === 'RR86') {
					this.vm.lastFetchDate = person.lastFetchRequested;
				}
			});
		}
	}
	
	selectPerson(person) {
		this.vm.loading = true;
		this.restService.getPreVisitInsertForPatientValidateUser({ 'userIdentifierCode': person.personalCode })
			.then((response) => {
				if (response.errorCode === 'USER_DOES_NOT_EXIST') {
					this.showCreateUserModal(person);
				} else {
					this.preVisitRecordTicketForPersonService.setPatient(response);
					if (person.statusInfo === 'LAPS') {
						this.vm.requesterRelationshipToPatient = 'DEPEN';
						this.preVisitRecordTicketForPersonService.setRequesterRelationshipToPatient(this.vm.requesterRelationshipToPatient);
						this.angularRoutingHelperService.setPath('/pre-visit');
					} else {
						this.vm.isValidatePatientStep2 = true;
					}
				}
				this.vm.loading = false;
			})
			.catch((errorResponse) => {
				this.vm.loading = false;
				if (errorResponse.error?.errorCode === 'NOT_SERVICED_BY_SAME_GP_ORG') {
					this.toast.showWithTranslation('PreVisit.Insert_For_Person.Not_Serviced_By_Same_Gp_Organization');
				} else {
					console.log(errorResponse);
				}
			});
	}
	
	showCreateUserModal(person) {
		var dialog = this.dialogServices.show({
			controller: ModalInsertForPersonCreateUserComponent,
			userEstonianIdentificationCode: person.personalCode,
			userFirstname: person.firstname,
			userLastname: person.lastname,
			isPatient: this.vm.isValidatePatientStep1
		});
		dialog.afterClosed().subscribe(
			user => {
				if (user) {
					this.preVisitRecordTicketForPersonService.setPatient(user);
					if (person.statusInfo === 'LAPS') {
						this.vm.requesterRelationshipToPatient = 'DEPEN';
						this.preVisitRecordTicketForPersonService.setRequesterRelationshipToPatient(this.vm.requesterRelationshipToPatient);
						this.angularRoutingHelperService.setPath('/pre-visit');
					} else {
						this.vm.isValidatePatientStep2 = true;
					}
				}
			},
			(error) => {
				console.log(error);
			}
		);
	}
	
	validatePatientRelationship() {
		if (this.vm.isValidatePatientStep2) {
			if (this.vm.requesterRelationshipToPatient) {
				this.vm.noConnectionDefined = false;
				this.preVisitRecordTicketForPersonService.setRequesterRelationshipToPatient(this.vm.requesterRelationshipToPatient);
				this.angularRoutingHelperService.setPath('/pre-visit');
			} else {
				this.vm.noConnectionDefined = true;
				this.vm.loading = false;
			}
		}
	}
	
	deleteCareTaken(person){
		var dialog = this.dialogServices.confirmation({
			content: this.angularFilterHelperService.translate('PreVisit.Insert_For_Person_List.Delete_Confirmation')
		});
		dialog.afterClosed().subscribe((modalResponse) => {
			if (modalResponse && modalResponse.isAccepted) {
				this.restService.deletePreVisitCareTakenHistory(person.id)
					.then((response) => {
						var foundIndex: any = this.vm.persons.findIndex(function(x) {
							return x.id === response.id;
						});
						this.vm.persons.splice(foundIndex, 1);
					})
					.catch((error) => {
						console.log(error);
					});
			}
		});
	}
	
}
